import React, { useEffect } from 'react';
import '../components/short/short.css';
import { ShortHero } from '../components/short/ShortHero';
import { ShortServices } from '../components/short/ShortServices';
import { ShortFAQ } from '../components/short/ShortFAQ';
import { ShortFooter } from '../components/short/ShortFooter';
import { MobileStickyCTA } from '../components/short/MobileStickyCTA';
import { useDocumentSEO } from '../utils/useDocumentSEO';

export default function ShortHomePage() {
  useDocumentSEO({
    title: 'Coutin Studio — Filmagem, Drone, Sites e Instagram em Foz do Iguaçu',
    description: 'Levamos o estúdio completo até sua empresa. Filmagem, aérea com drone, sites, landing pages e gestão do Instagram.',
    canonical: 'https://www.agenciacoutin.com.br/',
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="sh-root min-h-screen" data-testid="short-home-page">
      <ShortHero />
      <main>
        <ShortServices />
        <ShortFAQ />
      </main>
      <ShortFooter />
      <MobileStickyCTA />
    </div>
  );
}
